/**
 * Validate if a given string is a valid URL.
 * @param {string} url - The URL to validate.
 * @returns {boolean} True if valid, false otherwise.
*/

export const validateURL = (url) => {
  const urlPattern = new RegExp(
      '(([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}|localhost)' + // Domain name or localhost
      '(\\:[0-9]{1,5})?' + // Optional port
      '(\\/.*)?$', // Path
      'i' // Case insensitive
  );
  return urlPattern.test(url);
};

export const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
};

export const validateField = (fieldName, value, validatorFn, setErrors, errorMessage = 'Invalid value.') => {
    setErrors(prev => {
        const updated = { ...prev };
        if (value && !validatorFn(value)) {
            updated[fieldName] = errorMessage;
        } else {
            delete updated[fieldName];
        }
        return updated;
    });
};

export const validateRequiredField = (fieldName, value, setErrors, errorMessage = 'This field is required.') => {
    setErrors(prev => {
        const updated = { ...prev };
        if (!value.trim()) {
            updated[fieldName] = errorMessage;
        } else {
            delete updated[fieldName];
        }
        return updated;
    });
};
  